import React from "react";
import "@fontsource/carattere"; // Import the Carattere font
import "@fontsource/carattere/400.css"; // Import specific weight
import "@fontsource/roboto-condensed"; // Import Roboto Condensed font
import "@fontsource/roboto-condensed/400.css"; // Import normal weight
import "@fontsource/roboto-condensed/500.css"; // Import medium weight

import { Box } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import AppSection from "../components/homepage/AppSection";
import FounderSection from "../components/homepage/FounderSection";
import Footer from "../components/homepage/Footer";
import { styles } from "../components/styles/styles";
import Header from "../components/homepage/Header";
import HeroSection from "../components/homepage/HeroSection";
import WhyUsSection from "../components/homepage/WhyUsSection";
import OfferSection from "../components/homepage/OfferSection";
import HowItWorks from "../components/homepage/HowItWorksSection";
import ReviewsSection from "../components/homepage/ReviewsSection";
import AcheivementSection from "../components/homepage/AcheivementSection";
import PricingSection from "../components/homepage/PricingSection";
import SucessStoriesSection from "../components/homepage/SucessStoriesSection";

// Custom theme
const theme = createTheme({
	palette: {
		primary: {
			main: "#c77c2f",
		},
		secondary: {
			main: "#f3e6d5",
		},
	},
	typography: {
		fontFamily: "Arial, sans-serif",
	},
	background: {
		default: "#FFF7E9",
	},
});

const responsiveStyles = {
	mainWrapper: {
		flexGrow: 1,
		bgcolor: "rgba(247,233,211,255)",
		minHeight: "100vh",
		width: "100%",
		display: "flex",
		flexDirection: "column",
		overflow: "hidden",
	},
	contentWrapper: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		width: "100%",
		gap: { xs: 4, md:0 },
	},
	section: {
		width: "100%",
		maxWidth: "100%",
		px: { xs: 2, sm: 3, md: 4 },
		py: { xs: 2, sm: 4, md: 5 },
	},
	constrainedSection: {
		width: "100%",
		maxWidth:  "1405px",
		mx: "auto",
		px: { xs: 2, sm: 3, md: 4 },
		py: { xs: 2, sm: 4, md: 5 },

	},
};

const AnnapurnaMarriages = () => {
	return (
		<>
						<Header />
		<ThemeProvider theme={theme}>
			<Box sx={responsiveStyles.mainWrapper}>
				<HeroSection />

				<Box sx={responsiveStyles.contentWrapper}>
					{/* Why Us Section */}
					<Box sx={responsiveStyles.section}>
						<WhyUsSection />
					</Box>
					{/* Offer Section */}
					<Box sx={responsiveStyles.constrainedSection}>
						<OfferSection />
					</Box>
					{/* How It Works Section */}
					<Box sx={responsiveStyles.section}>
						<HowItWorks />
					</Box>
					{/* Success Stories Section */}
					<Box sx={responsiveStyles.section}>
						<SucessStoriesSection />
					</Box>
					{/* Reviews Section */}
					<Box sx={responsiveStyles.section}>
						<ReviewsSection />
					</Box>
					{/* Achievement Section */}
					<Box sx={responsiveStyles.section}>
						<AcheivementSection />
					</Box>
					{/* Constrained width sections */}
					<Box sx={responsiveStyles.constrainedSection}>
						<PricingSection styles={styles} />
					</Box>
					<Box sx={responsiveStyles.constrainedSection}>
						<AppSection styles={styles} />
					</Box>
					<Box sx={responsiveStyles.constrainedSection}>
						<FounderSection styles={styles} />
					</Box>
				</Box>

				<Footer />
			</Box>
		</ThemeProvider>
		</>

	);
};

export default AnnapurnaMarriages;
